import { Brand, IsoCountryCode2Char } from '../types';

export const DEFAULT_COUNTRY_BY_BRAND: Record<Brand, IsoCountryCode2Char> = {
  [Brand.BK]: IsoCountryCode2Char.US,
  [Brand.LTW]: IsoCountryCode2Char.US,
  [Brand.PLK]: IsoCountryCode2Char.US,
  [Brand.TH]: IsoCountryCode2Char.CA,
  [Brand.FHS]: IsoCountryCode2Char.US,
};

/**
 * Determine the default country value for a Brand.
 *
 * @param {Brand} brand
 * The Brand.
 *
 * @returns {IsoCountryCode2Char}
 * The default 2-character ISO country code for the Brand.
 */
export const getDefaultCountryForBrand = (brand: Brand): IsoCountryCode2Char =>
  DEFAULT_COUNTRY_BY_BRAND[brand];

/**
 * Given a country value, determine if it is the default country for a Brand.
 *
 * @param {Brand} brand
 * The Brand.
 *
 * @param {IsoCountryCode2Char | string} country
 * A country value.
 *
 * @returns {boolean}
 * true - The country value is the default for the Brand.
 * false - Otherwise.
 */
export const isDefaultCountryForBrand = (
  brand: Brand,
  country: IsoCountryCode2Char | string,
): boolean => getDefaultCountryForBrand(brand) === country;
